import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=3115047c&scoped=true&"
import script from "./premium.vue?vue&type=script&lang=js&"
export * from "./premium.vue?vue&type=script&lang=js&"
import style0 from "./premium.vue?vue&type=style&index=0&id=3115047c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115047c",
  null
  
)

export default component.exports